import TooltipReferenceTable from "../rules/TooltipReferenceTable";
import { TooltipDataType } from "../rules/models/TooltipData";


/**
 * @class TooltipDictionary
 * @description This class provides methods to search the TooltipReferenceTable.
 */
class TooltipDictionary {
    /**
     * @description This method searches the TooltipReferenceTable for a tooltip by name.
     * @param {string} name - The name of the tooltip to search for.
     * @returns {TooltipDataType | null} The tooltip data if found, otherwise null.
     */
    public static getTooltipByName(name: string): TooltipDataType | null {
        // Check if the name is in the TooltipReferenceTable
        const tooltip = TooltipReferenceTable.entries.find((t) => t.name === name);
        if (!tooltip) {
            return null;
        }
        // If the tooltip is found, return it
        return tooltip;
    }

    /**
     * @description This method searches the TooltipReferenceTable for a tooltip by name and returns the tip.
     * 
     * @param name - The name of the tooltip to search for.
     * @returns {string} The tooltip tip if found, otherwise an empty string.
     * @example TooltipDictionary.getTipByName('exampleTooltipName');
     */
    public static getTipByName(name: string): string {
        let result = '';
        const tooltip = TooltipDictionary.getTooltipByName(name);
        if (tooltip) {
            result = tooltip.tip;
        }
        return result;
    }

    

}

export default TooltipDictionary;
